var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"logo-icon",attrs:{"to":"/"}},[_c('img',{staticClass:"logo-icon-image",attrs:{"src":require("@/assets/logo-icon.svg"),"alt":"Logo"}})])}
var staticRenderFns = []

export { render, staticRenderFns }